import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const updateShadowProject = async (
  shadowProjectId,
  updates,
  activeEmployerInfo = {}
) => {
  const apiPath = `shadow-data/projects/${shadowProjectId}`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: updates,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
